<section #formStart class="centered-with-padding py-7 desk:px-[54px]">
  @if (data.title; as title) {
    <div class="mb-7">
      <app-title [title]="title" size="h1" />
    </div>
  }
  <div class="grid grid-cols-1 desk:grid-cols-2">
    <div class="flex flex-col gap-y-6">
      @let isSubmitted = isFormSubmitted();
      @let isInvalid = isFormValid().status === "KO";
      @let errors = isFormValid().errors!;
      <div class="relative">
        <label class="mb-1 block font-bold" for="firstName">
          {{ "GLOBAL.FORMS.LABEL_FIRST_NAME" | translate }}
        </label>
        <input
          (input)="onInputChange($event)"
          [value]="firstName()"
          class="h-7 w-full rounded-[10px] border px-4 py-5 desk:w-96"
          id="firstName"
          maxlength="255"
          type="text" />
        @if (isSubmitted && isInvalid && errors.firstName) {
          <div class="absolute -bottom-4 text-[10px] text-error">
            {{ errors.firstName | translate }}
          </div>
        }
      </div>
      <div class="relative">
        <label class="mb-1 block font-bold" for="lastName">{{ "GLOBAL.FORMS.LABEL_LAST_NAME" | translate }}</label>
        <input
          (input)="onInputChange($event)"
          [value]="lastName()"
          class="h-7 w-full rounded-[10px] border px-4 py-5 desk:w-96"
          id="lastName"
          maxlength="255"
          type="text" />
        @if (isSubmitted && isInvalid && errors.lastName) {
          <div class="absolute -bottom-4 text-[10px] text-error">
            {{ errors.lastName | translate }}
          </div>
        }
      </div>
      <div class="relative">
        <label class="mb-1 block font-bold" for="phone">{{ "GLOBAL.FORMS.LABEL_PHONE" | translate }}</label>
        <input
          (input)="onInputChange($event)"
          [value]="phone()"
          class="h-7 w-full rounded-[10px] border px-4 py-5 desk:w-96"
          id="phone"
          maxlength="16"
          type="tel" />
        @if (isSubmitted && isInvalid && errors.phone) {
          <div class="absolute -bottom-4 text-[10px] text-error">
            {{ errors.phone | translate }}
          </div>
        }
      </div>
      <div class="relative">
        <label class="mb-1 block font-bold" for="email">{{ "GLOBAL.FORMS.LABEL_EMAIL" | translate }}</label>
        <input
          (input)="onInputChange($event)"
          [value]="email()"
          class="h-7 w-full rounded-[10px] border px-4 py-5 desk:w-96"
          id="email"
          maxlength="255"
          type="email" />
        @if (isSubmitted && isInvalid && errors.email) {
          <div class="absolute -bottom-4 text-[10px] text-error">
            {{ errors.email | translate }}
          </div>
        }
      </div>
      <div>
        <div (click)="onShowNote()" class="mb-1 flex cursor-pointer items-center gap-x-2.5">
          <label class="cursor-pointer font-bold" for="note">{{
            "COMPONENT.FORMULAIRE-RDV.LABEL_CUSTOM_MESSAGE" | translate
          }}</label>
          <app-svg
            [height]="12"
            [ngClass]="{ 'rotate-90': showNote() }"
            class="transition-transform duration-300 ease-in-out"
            src="assets/icons/caret-right.svg" />
        </div>
        @if (showNote()) {
          <textarea
            (input)="onInputChange($event)"
            [value]="note()"
            class="h-36 w-full rounded-[10px] border px-4 py-5 desk:w-96"
            id="note"
            [placeholder]="'COMPONENT.FORMULAIRE-RDV.FORM_PLACEHOLDER_MESSAGE' | translate"></textarea>
        }
      </div>
      <div class="desk:w-96">
        <div class="mb-2 font-bold">{{ "GLOBAL.FORMS.LABEL_NEWSLETTER_OPTIN" | translate }}</div>
        <div class="grid grid-cols-2 gap-2">
          <div class="flex items-center gap-x-2">
            <input
              (input)="onInputChange($event)"
              [checked]="subscribeEmail()"
              class="size-5 cursor-pointer"
              id="subscribeEmail"
              type="checkbox" />
            <label class="cursor-pointer" for="subscribeEmail">{{
              "GLOBAL.FORMS.LABEL_OPTIN_EMAIL" | translate
            }}</label>
          </div>
          <div class="flex items-center gap-x-2">
            <input
              (input)="onInputChange($event)"
              [checked]="subscribeSms()"
              class="size-5 cursor-pointer"
              id="subscribeSms"
              type="checkbox" />
            <label class="cursor-pointer" for="subscribeSms">{{ "GLOBAL.FORMS.LABEL_OPTIN_SMS" | translate }}</label>
          </div>
        </div>
      </div>
    </div>
    <div>
      @if (slotSelected() && storeSelected()) {
        <div class="mt-9 desk:mt-0">
          <app-appointment-details
            (onSlotChange)="onSlotChange()"
            (onStoreChange)="onStoreChange()"
            [canEdit]="true"
            [slotSelected]="slotSelected()!"
            [storeSelected]="storeSelected()!" />
        </div>
      }
      <div class="flex justify-center py-5 desk:py-7" [class.pb-1]="serverError()" [class.desk:pb-1]="serverError()">
        <app-button (onButtonClick)="onSubmit()" [isLoading]="isSending()" [label]="data.cta.label" />
      </div>
      @if (serverError()) {
        <div class="mb-2.5 text-center text-[10px] text-error">
          @if (storeSelected()?.phone; as phone) {
            {{ "GLOBAL.FORMS.APPOINTMENT_SERVER_ERROR" | translate: { phone: phone.formatted } }}
          } @else {
            {{ "GLOBAL.FORMS.APPOINTMENT_SERVER_ERROR_NO_PHONE" | translate }}
          }
        </div>
      }
      @if (data.legalNoticeHtml; as legalNoticeHtml) {
        <div class="pb-2">
          <div [innerHTML]="legalNoticeHtml" handleHtmlLinks class="text-center"></div>
        </div>
      }
    </div>
  </div>
</section>
